angular.module('admin.directives')
  .directive('trialBanner', [function(){
    return {
      controllerAs: 'trialBannerCtrl',
      bindToController: {
        isBabAgent: '@',
        trialDaysLeft: '@'
      },
      scope: {},
      templateUrl: '/admin/templates/partials/trial-banner.html',

      controller: function(){
      }
    };
  }]);
